// Curated imagery — real Shambala House + editorial supplements
export const IMAGES = {
  hero: "https://a0.muscache.com/im/pictures/hosting/Hosting-1526908413891989748/original/cf7536a9-4ca1-4a88-b107-1fbe66d51edf.jpeg",
  heroAlt: "https://a0.muscache.com/im/pictures/hosting/Hosting-1526908413891989748/original/59ff3583-aaed-49e7-a291-047e23e35434.png",
  arch: "https://a0.muscache.com/im/pictures/hosting/Hosting-1526908413891989748/original/6ac93b7a-c307-4995-ace2-21fb61a4e87c.jpeg",
  facade: "https://a0.muscache.com/im/pictures/hosting/Hosting-1526908413891989748/original/fde33b31-ebc4-412f-b197-fc0f72246829.jpeg",
  interior: "https://a0.muscache.com/im/pictures/hosting/Hosting-1526908413891989748/original/b7309e0a-6e09-40e2-a5ea-3b00a338fbe5.png",
  suite: "https://a0.muscache.com/im/pictures/hosting/Hosting-1526908413891989748/original/87af0a10-6bfd-49d8-86ac-9f90420a775a.png",
  bedroom2: "https://a0.muscache.com/im/pictures/hosting/Hosting-1526908413891989748/original/feafbada-1595-42b8-89eb-d5c904b3461a.png",
  bedroom3: "https://a0.muscache.com/im/pictures/hosting/Hosting-1526908413891989748/original/c5f946ee-0608-4f71-abea-78e53a7cacf6.png",
  // Editorial supplements
  poolNight: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=1800&q=80",
  jacuzzi: "https://images.unsplash.com/photo-1583445095369-9c651e7e5d34?auto=format&fit=crop&w=1800&q=80",
  fire: "https://images.unsplash.com/photo-1478131143081-80f7f84ca84d?auto=format&fit=crop&w=1800&q=80",
  gym: "https://images.unsplash.com/photo-1637666505365-01e0b0fe7be9?auto=format&fit=crop&w=1800&q=80",
  sauna: "https://images.unsplash.com/photo-1717356495389-6ab1e5ff9d84?auto=format&fit=crop&w=1800&q=80",
  greenery: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1800&q=80",
  concrete: "https://images.unsplash.com/photo-1600566753376-12c8ab7fb75b?auto=format&fit=crop&w=1800&q=80",
};

export const SCHEDULE = [
  {
    day: "Dia I",
    date: "04.08.2026",
    theme: "Chegada. Silêncio. Escolha da luz.",
    items: [
      { time: "17h00", title: "Check-in & Recepção", desc: "Boas-vindas com welcome-drink no lobby de concreto." },
      { time: "18h30", title: "Tour pelos Cenários", desc: "Passeio pelas varandas com curadoria de bebidas e primeiro contato com os cenários." },
      { time: "20h30", title: "Jantar ao redor da fogueira", desc: "Menu autoral no Solário. Fogo, céu aberto e conversas longas." },
    ],
  },
  {
    day: "Dia II",
    date: "05.08.2026",
    theme: "Produção. Corpo. Estética.",
    items: [
      { time: "08h00", title: "Café da manhã gourmet", desc: "Na cozinha aberta, com luz da manhã e frutas do dia." },
      { time: "09h30", title: "Sessão de fotos 01", desc: "Piscina de ozônio e academia envidraçada." },
      { time: "15h00", title: "Sessão de fotos 02", desc: "Suíte master, luz natural, moda editorial." },
      { time: "18h00", title: "Pôr do sol na Jacuzzi", desc: "Cobertura, taças e o céu de São Paulo derretendo em laranja." },
      { time: "20h30", title: "Jantar harmonizado", desc: "Menu degustação, vinho e conteúdo lento." },
    ],
  },
  {
    day: "Dia III",
    date: "06.08.2026",
    theme: "Legado. Encerramento.",
    items: [
      { time: "08h30", title: "Café da manhã", desc: "Último café coletivo, no jardim." },
      { time: "10h00", title: "Gravação em grupo", desc: "Vídeos rápidos, entregáveis e agradecimentos." },
      { time: "12h00", title: "Check-out", desc: "Encerramento oficial. O que fica é o material — e a memória." },
    ],
  },
];

export const SCENARIOS = [
  {
    key: "oasis",
    tag: "01 — The Oasis",
    title: "Piscina de ozônio, 4 m de profundidade",
    body:
      "Cristalina, aquecida por energia solar, com trampolim de inox de três metros. Cercada por poltronas flutuantes e uma vegetação que apaga a cidade.",
    images: [ "hero", "arch" ],
  },
  {
    key: "summit",
    tag: "02 — The Summit",
    title: "Concreto, vidro e o céu de São Paulo",
    body:
      "Escadas de concreto, três varandas, jacuzzi Yemanjá aquecida solar e um tacho de fogo pronto para noites estreladas. Onde o dia termina.",
    images: [ "heroAlt", "facade" ],
  },
  {
    key: "studio",
    tag: "03 — The Studio",
    title: "Suíte master, integrada às varandas",
    body:
      "Cama king, luz da manhã abundante, acesso direto ao trampolim. Um estúdio natural para moda, retratos e séries de conteúdo.",
    images: [ "suite", "interior" ],
  },
  {
    key: "lab",
    tag: "04 — The Lab",
    title: "Quartos, academia envidraçada & sauna úmida",
    body:
      "Três suítes tratadas como cenários: linho, tons terrosos e muita luz natural. Ao lado, academia com vista panorâmica e sauna úmida para o corpo lembrar de descansar.",
    images: [ "bedroom2", "bedroom3" ],
  },
];

// -------- CREATORS / CAST --------
// Fotos fornecidas pelo cliente. Handles são placeholders — trocar pelos reais
// quando divulgar a seleção completa das creators convidadas.
export const CAST = [
  {
    src: "https://customer-assets.emergentagent.com/job_shambala-retreat/artifacts/m454von1_image.png",
    handle: "@sunny.bikini",
    vibe: "Praia · Cover",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_shambala-retreat/artifacts/qkv7xk37_image.png",
    handle: "@laranja.studio",
    vibe: "Studio · Moda",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_shambala-retreat/artifacts/993fp968_image.png",
    handle: "@axe.trancinhas",
    vibe: "Direct to camera · Lifestyle",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_shambala-retreat/artifacts/lfdrt23k_image.png",
    handle: "@ruiva.on",
    vibe: "Retrato · Editorial",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_shambala-retreat/artifacts/hpngopu0_image.png",
    handle: "@rede.selfie",
    vibe: "BTS · Rede",
  },
  {
    src: null,
    handle: "@?????",
    vibe: "Reveal · 08.2026",
    reveal: true,
  },
];

// Subset used inside the hero collage
export const CAST_HERO = [
  {
    src: "https://customer-assets.emergentagent.com/job_shambala-retreat/artifacts/m454von1_image.png",
    handle: "@sunny.bikini",
    vibe: "Praia · Cover",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_shambala-retreat/artifacts/qkv7xk37_image.png",
    handle: "@laranja.studio",
    vibe: "Studio · Moda",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_shambala-retreat/artifacts/lfdrt23k_image.png",
    handle: "@ruiva.on",
    vibe: "Retrato · Editorial",
  },
];
